import { memberCalls2Post } from '@/core/http'

export type RecaptchaV3VerifyResponse = {
    gg_success?: boolean
    isAccepted?: boolean
    success?: boolean
}

export const verifyTokenRecaptchaV3 = (googleToken: string) => {
    const qs = new URLSearchParams(window.location.search)
    const data = {
        ...(qs.get('is_bot') === '1' && { is_bot: true }),
        ...(qs.get('is_random_score') === '1' && { is_random_score: true }),
        g_token: googleToken
    }

    return memberCalls2Post<RecaptchaV3VerifyResponse>('bot-protection/recaptchaV3/verify', data)
}
